import { TagSchemaField } from '@/core/notifications/model';
import { fieldLeafKeys } from '@/core/notifications/model/tag-schema';

// tagFilter values are scalar (exact match) or array (any-of); the form edits everything
// as a list of strings and collapses single values back to scalars on submit
export function toValueList(value: unknown): string[] {
  if (value === undefined || value === null) return [];
  if (Array.isArray(value)) return value.map(String);
  return [String(value)];
}

export function buildTagFilterFromValues(
  tagValues: Record<string, string[]>,
): Record<string, unknown> {
  const tagFilter: Record<string, unknown> = {};
  Object.entries(tagValues).forEach(([tagKey, values]) => {
    if (values.length === 1) tagFilter[tagKey] = values[0];
    else if (values.length > 1) tagFilter[tagKey] = values;
  });
  return tagFilter;
}

export function missingRequiredTags(
  tagSchema: Record<string, TagSchemaField>,
  tagValues: Record<string, string[]>,
): string[] {
  return Object.entries(tagSchema)
    .filter(([, field]) => field.required)
    .filter(([tagKey]) => (tagValues[tagKey] ?? []).length === 0)
    .map(([tagKey]) => tagKey);
}

// stored values that are no longer leaves (removed keys, or keys that became groups);
// the backend rejects them with 422, so Save stays disabled until they are removed
export function invalidTagValues(
  tagSchema: Record<string, TagSchemaField>,
  tagValues: Record<string, string[]>,
): Record<string, string[]> {
  const invalid: Record<string, string[]> = {};
  Object.entries(tagSchema).forEach(([tagKey, field]) => {
    if (!field.allowed || field.allowed.length === 0) return;
    const leaves = fieldLeafKeys(field);
    const invalidValues = (tagValues[tagKey] ?? []).filter(value => !leaves.includes(value));
    if (invalidValues.length > 0) invalid[tagKey] = invalidValues;
  });
  return invalid;
}
